import cn from 'classnames';
import type React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowShortLeft } from '@shared/assets';
import { useUser } from '@shared/hooks';
import { IconButton } from '@shared/ui';
import * as st from './styles.module.scss';

type Props = {
  comeBackButton?: string;
  page?: 'main' | 'search' | undefined;
};

export const NavLeftCenter: React.FC<Props> = ({ page = undefined, comeBackButton }) => {
  const { isAuth } = useUser();
  return (
    <>
      <div className={st.nav}>
        {page === 'main' && (
          <>
            <NavLink
              to={`products`}
              className={({ isActive }) => cn(st.tab, isActive && st.active)}
            >
              Каталог
            </NavLink>

            {isAuth && (
              <NavLink
                to={`orders`}
                className={({ isActive }) => cn(st.tab, isActive && st.active)}
              >
                Заказы
              </NavLink>
            )}
          </>
        )}

        {page !== 'main' && (
          <>
            <Link to={`${comeBackButton}`}>
              <IconButton variant="dark" id="buttonPrev">
                <ArrowShortLeft />
              </IconButton>
            </Link>
          </>
        )}
      </div>
    </>
  );
};
